import * as API from "./Api";

export const getAllCreators = (page, limit) =>
  API.get(`spotlight?page=${page}&limit=${limit}`);
export const requestJobToCreator = (data) => API.post("request-for-job", data);
